import type { BrandKey } from '../config/brands.config'

/**
 * Marca de "paciente acabou de se identificar" no funil whitelabel anônimo
 * (Remederi/Vikura).
 *
 * O agendamento branded passa para a Consulta na Hora via `history.state`
 * (`fromSchedulingIdentification`), mas esse state se perde em F5, voltar /
 * avançar do navegador e quando o `usePreserveUTM` reescreve a URL — e o
 * paciente caía de novo na tela de dados. A marca fica no sessionStorage (só
 * esta aba) com TTL curto, amarrada à marca e ao usuário identificado, para
 * manter a regra "dados primeiro em toda visita" sem pedir os dados de novo
 * a cada reload.
 */
const KEY = '@CANNECT_BRANDED_IDENTIFIED'
const TTL_MS = 30 * 60 * 1000

interface BrandedIdentification {
  brand: BrandKey
  userId: number | string | null
  at: number
}

export const markBrandedIdentification = (brand: BrandKey, userId: number | string | null): void => {
  try {
    const value: BrandedIdentification = { brand, userId, at: Date.now() }
    sessionStorage.setItem(KEY, JSON.stringify(value))
  } catch {
    // sessionStorage indisponível: o fluxo segue pelo history.state
  }
}

export const hasRecentBrandedIdentification = (brand: BrandKey): boolean => {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return false
    const value = JSON.parse(raw) as BrandedIdentification
    return value.brand === brand && Date.now() - value.at < TTL_MS
  } catch {
    return false
  }
}

export const clearBrandedIdentification = (): void => {
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // nada a limpar
  }
}
